var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[(!_vm.first && _vm.$store.getters.totalAddressHistory < _vm.requiredYears)?_c('p',[_vm._v("Next, we'll ask for another "+_vm._s(_vm.needed)+" of your address history.")]):_vm._e(),(!_vm.first && _vm.$store.getters.totalAddressHistory >= _vm.requiredYears)?_c('p',[_vm._v("Great, that's the last address we need.")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }